<template>
    <div>
        <b-modal
            id="shipping_address_modal"
            modal-class=""
            centered
            hide-header
            hide-footer
            no-close-on-backdrop
            no-close-on-esc>
            <div class="modal-base">
                <div class="modal-base-head">
                    <div class="modal-base-close" @click="clickCloseAddressModal()"></div>
                    <p>{{lblShipping.headline}}</p>
                </div>
                <div class="modal-base-body"
                    v-if="shippingAddress">
                    <text-input
                        inputId="shipping_firstname"
                        v-model="shippingAddress.strFirstName"
                        :inputLbl="lblShipping.firstname"
                        :isFirstSave="isFirstSave"
                        :isShowErrorLbl="isShowErrorLbl"
                        :errorInfo="arrErrorInfo[0]"
                        :isTextOnly="true"
                        ></text-input>
                    <text-input
                        inputId="shipping_lastname"
                        v-model="shippingAddress.strLastName"
                        :inputLbl="lblShipping.lastname"
                        :isFirstSave="isFirstSave"
                        :isShowErrorLbl="isShowErrorLbl"
                        :errorInfo="arrErrorInfo[1]"
                        :isTextOnly="true"
                    ></text-input>
                    <text-input
                        inputId="shipping_address"
                        v-model="shippingAddress.strAddress"
                        :inputLbl="lblShipping.address"
                        :isFirstSave="isFirstSave"
                        :isShowErrorLbl="isShowErrorLbl"
                        :errorInfo="arrErrorInfo[2]"
                        ></text-input>
                    <form-address-dropdown
                        :address="shippingAddress"
                        formId="shipping"
                        :lblShipping="lblShipping"
                        :isFirstSave="isFirstSave"
                        :isShowErrorLbl="isShowErrorLbl"
                        :zipcodeError="arrErrorInfo[3]"
                        :subDistrictError="arrErrorInfo[4]"
                        :districtError="arrErrorInfo[5]"
                        :provinceError="arrErrorInfo[6]"
                        :busModal="busModal"
                        ></form-address-dropdown>
                    <email-input
                        inputId="shipping_email"
                        v-model="shippingAddress.strEmail"
                        :inputLbl="lblShipping.email"
                        :isFirstSave="isFirstSave"
                        :isShowErrorLbl="isShowErrorLbl"
                        :errorInfo="arrErrorInfo[7]"
                        ></email-input>
                    <contact-number-input
                        inputId="shipping_contact_number"
                        v-model="shippingAddress.strContactNumber"
                        :inputLbl="lblShipping.contactnumber"
                        :isFirstSave="isFirstSave"
                        :errorInfo="arrErrorInfo[8]"
                        ></contact-number-input>
                    <check-box
                        :textLbl="lblShipping.save_address"
                        v-model="isSaveAddress"
                    ></check-box>
                </div>
                <div class="modal-base-footer">
                    <button class="btn btn-secondary mr-2" @click="clickConfirmAddress()">{{lblShipping.confirm_btn}}</button>
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
//import Vue from "vue";
import TextInput from "@/components/common/input/Text.vue";
import EmailInput from "@/components/common/input/Email.vue";
import ContactNumberInput from "@/components/common/input/ContactNumber.vue";
import CheckBox from "@/components/common/input/CheckBox.vue";
import FormAddressDropdown from "@/components/common/form/FormAddressDropDown.vue";
/**
 * Property
 * @property {lblShipping} (required) Text for component
 * @property {shippingAddress} (required) Shipping address model for redeem.
 * @property {errorInfo} (required) Validate status.
 * Event
 * @event clickConfirmAddress Validate and emit back to parent.
 * @event clickCloseShippingAddressModal Close modal.
 * Method
 * @method initialShippingAddressModal Setup shipping modal
 * @method closeShippingAddressModal Close modal.
 * @method validateForm Validate form.
 */
export default {
    name : 'ShippingAddressModal',
    components: {
        TextInput,
        EmailInput,
        ContactNumberInput,
        CheckBox,
        FormAddressDropdown
    },
    props: {
        lblShipping: Object,
        shippingAddress: Object,
        errorInfo: Object,

        busModal: Object,
        busShippingModal: Object
    }, 
    data: function () {
        return {
            isSaveAddress: false,
            isShowErrorLbl: true,
            isFirstSave: true,
            arrErrorInfo: [],
        };
    },
    created: function () {
        for(var i = 0;i < 9; i++) {
            this.arrErrorInfo.push({
                isValid: true,
                msg: '',
            });
        }
    },
    mounted: function () {
        this.busShippingModal.$on('showShippingAddressModal', this.initialShippingAddressModal);
        this.busShippingModal.$on('hideShippingAddressmodal', this.closeShippingAddressModal);
    },
    methods: {
        //Event
        clickConfirmAddress: function () {
            this.validateForm();

            this.$emit('clickConfirmAddress');
            this.closeAddressModal();
            this.isFirstSave = false;
        },
        clickCloseAddressModal: function () {
            this.isFirstSave = true;
            this.closeAddressModal();
        },
        //Function
        initialShippingAddressModal: function () {
            this.$bvModal.show('shipping_address_modal');
        },
        closeAddressModal: function () {
            this.$bvModal.hide('shipping_address_modal');
        },
        validateForm: function () {
            //Set default.
            this.errorInfo.isValid = true;
            this.errorInfo.msg = '';
            //Check validate result and update.
            for(var error of this.arrErrorInfo) {
                if(!error.isValid) {
                    this.errorInfo.isValid = false;
                    this.errorInfo.msg = error.msg;
                    
                    return;
                }
            }
        }
    }
}
</script>
<style lang="scss" scoped>
@import "@/style/base/component/modal/modal.scss";

#shipping_address_modal {
    @extend %modal-base;
}

#headline {
    font-size: 1.25rem;
    font-weight: bold;
}
</style>